import { Search, X } from "lucide-react";
import { Input } from "snap-design-system";
import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface SearchInputProps {
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear: () => void;
  className?: string;
  disabled?: boolean;
  "data-test-id"?: string;
  startContent?: React.ReactNode;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      placeholder = "Procurar",
      onChange,
      onKeyDown,
      onClear,
      className = "",
      disabled = false,
      "data-test-id": dataTestId,
      startContent,
    },
    ref
  ) => {
    const inputElement = (
      <Input
        ref={ref}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        icon={value ? <X size={18} /> : <Search size={18} />}
        iconPosition="right"
        onIconClick={value ? onClear : undefined}
        maxLength={100}
        fullWidth
        className={startContent ? "border-0 rounded-none flex-1" : className}
        data-test-id={dataTestId}
        aria-label={value ? "Limpar busca" : "Buscar"}
      />
    );

    if (!startContent) {
      return inputElement;
    }

    return (
      <div
        data-has-value={value ? "true" : undefined}
        className={cn(
          "flex items-center border border-input rounded-xs overflow-hidden group/search",
          "focus-within:border-accent-500 data-has-value:border-accent-500",
          className
        )}
      >
        {startContent}
        {inputElement}
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";
